import { css } from '@mildang/styled-system/css';

import Link from '@mildang/design-system-legacy/esm/components/molecules/Link';
import NestedList from '@mildang/design-system-legacy/esm/components/molecules/document/NestedList';
import SubTitle from '@mildang/design-system-legacy/esm/components/molecules/document/SubTitle';
import Layout from '@mildang/design-system-legacy/esm/components/molecules/document/Layout';
import Text from '@mildang/design-system-legacy/esm/components/molecules/document/Text';
import Title from '@mildang/design-system-legacy/esm/components/molecules/document/Title';
import ChapterTitle from '@mildang/design-system-legacy/esm/components/molecules/document/ChapterTitle';
import { DocumentContext } from '@mildang/design-system-legacy/esm/components/molecules/document/DocumentContext';

export const content = (
  <>
    <Title>서비스 이용약관</Title>

    <ChapterTitle>제1장 총칙</ChapterTitle>

    <SubTitle>제1조 목적</SubTitle>
    <Text>
      이 약관은 아이헤이트플라잉버그스 주식회사(이하 “회사”)가 제공하는 [웹 및 모바일 어플리케이션] 서비스
      [밀당PT/밀당과외/밀당영어/밀당수학](이하 “기본서비스”) 의 이용과 관련하여 회사와 회원과의 권리, 의무 및
      책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
    </Text>

    <SubTitle>제2조 정의</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `이 약관에서 사용하는 용어의 정의는 다음과 같습니다.`,
          items: [
            {
              text: '“기본서비스”란 회원의 단말기(스마트폰, 태블릿PC, PC 등 각종 유무선 장치를 포함)로 이용할 수 있는 기본서비스 웹, 애플리케이션 또는 그 웹이나 애플리케이션을 통해서 제공하는 제6조의 서비스를 말합니다.',
            },
            {
              text: '“회원”이라 함은 기본서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결함으로써 기본서비스를 이용하는 학생 또는 해당 학생의 학부모 등 보호자(보호자가 회원인 경우에는 그 보호자의 학생도 회원으로 봅니다)를 말합니다.',
            },
            {
              text: '“아이디“란 회원의 식별과 기본서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 말합니다.',
            },
            {
              text: '“비밀번호”란 회원이 그 아이디를 개설한 회원 본인임을 증명하기 위해서 정하고 회사가 승인하는 문자와 숫자의 조합을 말합니다. ',
            },
          ],
        },
        {
          text: '이 약관에서 사용하는 용어 중 본 조에서 정하지 아니한 것은 기본서비스 화면상 안내, 운영정책, 개별약관 등 및 관련 법령에서 정하는 바에 따르며, 그 외에는 일반 관례에 따릅니다.',
        },
      ]}
    />

    <SubTitle>제3조 약관 명시, 개정</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회사는 이 약관의 내용을 회원이 쉽게 확인할 수 있도록 기본서비스 초기 화면에 공지합니다.`,
        },
        {
          text: '회사는 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』, 『학원의 설립·운영 및 과외교습에 관한 법률』, 『전자상거래 등에서의 소비자보호에 관한 법률』 등 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.',
        },
        {
          text: '회사가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 그 개정약관의 적용일자 7일(다만, 회원에게 불리한 변경을 할 때에는 적용일자 30일) 이전부터 적용일자 전일까지 기본서비스 화면에 공지하며, 이 경우 공지 외에 회원의 전자우편 등 전자적 수단을 통해 별도로 명확히 통지합니다. 단, 본 약관의 권리, 의무에 영향을 주지 않는 기본서비스에 대한 새로운 기능과 관련된 변경이나 법률적인 사유로 인한 변경은 사전 공지 없이 즉시 발효될 수 있습니다. 약관을 개정할 경우 회사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도록 표시합니다.',
        },
        {
          text: '회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 개정약관 적용일자 전까지 적용 거부의 의사표시를 하지 않으면 개정약관 적용에 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 적용 거부의 의사표시를 하지 아니한 경우 회원이 개정약관 적용에 동의한 것으로 봅니다.',
        },
        {
          text: '회원이 개정약관의 내용에 명시적으로 적용 거부의 의사표시를 한 경우 회사는 해당 회원에 대하여 개정약관의 내용을 적용할 수 없으며, 해당 회원은 개정약관의 효력 발생일부터 기본서비스를 이용하실 수 없습니다.',
        },
        {
          text: '회원은 기본서비스의 화면에서 이 약관의 내용을 확인할 의무가 있으며, 개정된 약관에 동의한 회원이 약관의 변경으로 인하여 입은 피해 및 회원의 확인 소홀로 개정된 약관의 내용을 알지 못해 발생하는 피해에 대해서 회사는 책임지지 않습니다.',
        },
      ]}
    />

    <SubTitle>제4조 약관 외 준칙</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회사는 필요한 경우 기본서비스 내 유료 서비스 등 특정 서비스에 관하여 별도로 이용약관 및 정책(이하 "개별약관 등")을 정하여 운영할 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 개별약관 등이 우선하여 적용됩니다.`,
        },
        {
          text: '이 약관에 명시되지 않은 사항은 화면상 안내, 운영정책, 개별약관 등, 『학원의 설립·운영 및 과외교습에 관한 법률』, 『전자상거래등에서의 소비자보호에 관한 법률』 등 관련 법령의 규정 또는 일반 관례에 따릅니다.',
        },
      ]}
    />

    <ChapterTitle>제2장 이용계약</ChapterTitle>

    <SubTitle>제5조 이용계약 체결</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `기본서비스 이용계약은 회원이 되고자 하는 자(이하 “가입신청인”)가 회원가입 화면 상에서 기입을 요구하는 정보를 입력하고 화면 상에서 요구하는 본인인증 절차를 완료한 후 이용신청을 하고 “개인정보 수집·이용 동의” 및 이 약관에 동의한 후(회원이 보호자인 경우에는 보호자 본인 정보가 아니라 학생의 정보를 기입할 수 있으며, 본인 뿐만 아니라 학생의 동의까지 한 것으로 봅니다), 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.`,
        },
        {
          text: '가입신청인이 기본서비스를 이용하기 위해서는 회사가 요청하는 정보를 정확하게 기재해야 하며, 기재 내용에 허위, 누락, 오기 등이 있는 경우 인한 불이익 및 법적 책임은 가입신청인에게 있습니다.',
        },
        {
          text: '가입신청인이 이전에 회원자격을 상실한 적이 있는 경우, 이미 회원가입한 자인 경우, 허위의 명의 또는 타인의 명의를 이용하는 등 회사가 요청하는 정보를 기입하지 아니하거나 정확하게 기입하지 아니한 경우, 미성년자가 보호자를 가장하여 가입하는 경우, 자신 또는 타인의 영리 목적 등 부당한 회원 가입 신청임이 확인된 경우, 기타 승낙이 불가능한 합리적인 사유가 있는 경우 승낙이 거부될 수 있습니다.',
        },
        {
          text: '회사는 기본서비스 관련 설비 등의 여유 기타 기술상 또는 업무상의 이유로 승낙을 유보할 수 있으며, 이에 해당할 경우 가입신청인에게 알려드립니다.',
        },
      ]}
    />

    <ChapterTitle>제3장 서비스</ChapterTitle>

    <SubTitle>제6조 서비스 내용</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회사가 회원에게 기본서비스에 게시된 이용요금 정책에 따라 제공하는 서비스는 다음 각 호와 같습니다. 단, 현 시점의 관련 법령, 기술의 수준에 따라 일부 서비스의 제공은 제한될 수도 있습니다.`,
          type: 'ordered',
          items: [
            {
              text: '강의 동영상 제공 서비스: 기본서비스를 통해서 스트리밍 방식으로 회원에게 교과과목 강의 동영상을 청취할 수 있게 하는 서비스',
            },
            {
              text: '교육 콘텐츠 제공 서비스: 기본서비스를 통해서 회원에게 교과과목에 관한 연습문제 등 텍스트 콘텐츠를 회원 맞춤형으로 추천하고 회원이 열람할 수 있게 하는 서비스',
            },
            {
              text: '학습 관리 서비스: 회원의 학습 접속 빈도 관리, 학습 시간 중 실시간 집중 여부 감독, 권고, 실시간 질의응답 등 회원의 학습을 실시간으로 관리해 주는 서비스',
            },
            {
              text: '기타 위 각 호를 위해서 필요한 부수 서비스',
            },
          ],
        },
        {
          text: `회사는 제1항의 서비스 외에도 서비스를 추가 개발하여 회원에게 제공할 수 있습니다.`,
        },
        {
          text: `서비스는 유료이며, 회사는 서비스의 종류, 관리교사의 선정 및 변경, 이용요금, 환불에 관한 개별약관을 마련하여 회원에게 개별약관에 관한 동의를 요청 드리거나 회원이 이용요금을 결제하기 전에 서비스의 종류, 관리교사의 선정 및 변경, 이용요금, 환불에 관한 정책을 확인할 수 있도록 제시할 것입니다.`,
        },
      ]}
    />

    <SubTitle>제7조 서비스 중지, 변경 및 종료</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회사는 기술상 또는 업무상의 필요에 따라 기본서비스의 전부 또는 일부를 중지, 변경 또는 종료할 수 있으며, 이에 대하여 약관, 이용요금 정책에 다른 규정이 없는 한 회원에게 별도의 배상이나 보상을 하지는 않습니다.`,
        },
        {
          text: `기본서비스를 중지, 변경하는 경우 중지, 변경사유 및 일자, 변경내용을 중지, 변경 3일 전에, 기본서비스를 종료하는 경우 30일 전에 기본서비스 초기 화면에 공지합니다. 다만, 사전에 공지할 수 없는 부득이한 사정이 있는 경우에는 사후에 지체 없이 이를 공지할 수 있습니다.`,
        },
        {
          text: `기본서비스 종료 공지일부터 종료일까지 기본서비스의 일부가 제한될 수 있습니다.`,
        },
        {
          text: `회사는 이 약관, 이용요금 정책 및 관련 법령에 특별한 규정이 없는 한 기본서비스의 변경, 종료로 인하여 회원에게 일체의 책임을 부담하지 않습니다.`,
        },
      ]}
    />

    <SubTitle>제8조 저작권 등의 귀속 등</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `기본서비스 또는 기타 회사가 운영하는 정보통신망에 게시된 내용에 대한 저작권은 회원의 작성 게시물을 제외하고는 모두 회사에게 귀속됩니다.`,
        },
        {
          text: `회사 또는 기본서비스의 상표, 로고 등 식별지, 기본서비스의 일체의 콘텐츠에 관한 지적재산권 등의 권리는 회사에 귀속합니다.`,
        },
        {
          text: `회원이 기본서비스에 게시한 게시물의 저작권 및 책임은 게시자 본인에게 있으며, 회원이 기본서비스에 게시한 정보나 의견은 회사의 입장과는 무관합니다. 회사는 회원이 서비스에 게재한 각종 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지 않습니다.`,
        },
        {
          text: `회원이 기본서비스에 게시한 게시물로 파생되는 문제에 대해서는 전적으로 해당 게시물을 게시한 회원에게 책임이 있습니다.`,
        },
        {
          text: `회원은 회사의 사전 승낙 없이 자신의 작성 게시물을 제외한 게시물의 내용을 복제, 배포, 전송하거나 사용하거나 제3자로 하여금 사용하게 해서는 아니 됩니다. 회원의 작성 게시물은 회사의 기본서비스 운영, 개선, 홍보, 프로모션, 마케팅, 판촉 등을 위하여 임의의 정보통신망에 복제, 배포, 전송, 게시, 노출될 수 있으며, 본질적인 내용에 변경을 가하지 않는 범위 내에서 수정, 편집될 수 있습니다.`,
        },
        {
          text: `회사는 회원이 작성한 게시물이 관련 법령에 위반되거나 음란 또는 청소년에게 유해한 게시물, 차별 갈등을 조장하는 게시물, 도배 · 광고 · 홍보 · 스팸성 게시물, 계정을 양도 또는 거래하는 내용의 게시물, 타인을 사칭하는 게시물, 타인의 권리를 침해하는 게시물 등이라고 판단되는 경우 이를 삭제하거나 게시를 거부할 수 있습니다.`,
        },
        {
          text: `회사는 회사의 게시물 정책에 따른 기간이 도과한 게시물은 임의로 삭제하거나 게시를 차단할 수 있습니다.`,
        },
      ]}
    />

    <SubTitle>제9조 게시물의 관리</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회원의 게시물이 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』 및 『저작권법』 등 관련법령에 위반되는 내용을 포함하는 경우, 또는 타인의 권리를 침해하여 권리자의 요청이 있는 경우 회사는 해당 게시물의 게시중단 및 삭제 등 관련법령에 따라 조치를 취하여야 합니다.`,
        },
        {
          text: `회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법령에 위반되는 경우에는 관련법령에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.`,
        },
      ]}
    />

    <ChapterTitle>제4장 계약당사자의 의무</ChapterTitle>

    <SubTitle>제10조 회사의 의무</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회사는 관련 법령 또는 이 약관을 위반하지 않으며, 계속적이고 안정적으로 기본서비스를 제공하기 위하여 최선을 다합니다.`,
        },
        {
          text: `회사는 회원이 안전하게 기본서비스를 이용할 수 있도록 개인정보 보호를 위한 보안시스템을 갖추어야 하며, 개인정보처리방침을 회원이 늘 확인할 수 있도록 기본서비스 화면에 공시하고 이를 준수합니다.`,
        },
        {
          text: `회사는 기본서비스 이용과 관련한 회원의 의견이나 불만사항 등이 정당하다고 인정할 경우 이를 처리하여야 합니다. 처리된 결과는 기본서비스를 통하여 회원에게 통보됩니다.`,
        },
      ]}
    />

    <SubTitle>제11조 회원의 의무</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: `회원은 기본서비스 이용과 관련하여 다음의 행위를 하여서는 안됩니다.`,
          type: 'ordered',
          items: [
            { text: '기본서비스 이용 관련 제반 신청 및 변경행위 시 허위내용의 등록' },
            { text: '기본서비스 내 게시된 각종 정보의 무단 변경, 삭제 등 훼손 ' },
            { text: '일체의 가공행위를 통해 기본서비스를 분해, 변경, 모방하는 행위 ' },
            { text: '회사 기타 제3자의 지적재산권을 포함하여 권리를 침해하는 행위 ' },
            { text: '다른 회원의 개인정보 수집하거나 명예를 손상하는 행위 ' },
            { text: '회사의 동의 없이 광고를 전송하거나 외설, 폭력적인 정보 등을 노출하는 행위' },
            { text: '타인의 개인정보 또는 단말기를 도용하는 행위' },
            {
              text: '회사가 안내하는 기본서비스 이용방법에 의하지 아니하고 비정상적인 방법으로 서비스를 이용하거나 회사의 시스템에 접근하는 행위',
            },
            { text: '회사의 원활한 서비스 제공에 지장을 주는 것으로 판단되는 행위' },
            { text: '자신 또는 타인의 영리 목적으로 기본서비스를 이용하는 행위' },
            { text: '기본서비스 내의 정보를 기본서비스 외에 복제, 편집, 번역, 출판, 배포, 공개하는 행위 ' },
            { text: '회원이 가입시 개인정보를 허위로 작성하는 행위' },
            { text: '다른 회원의 기본서비스 이용을 방해하는 행위' },
            { text: '기본서비스 외에서 회사, 운영자, 임직원 등을 사칭하는 행위' },
            {
              text: '무단으로 회사의 클라이언트 프로그램을 변경하거나 서버를 해킹하는 등 시스템을 위협하는 행위',
            },
            {
              text: '허위사실 유포, 위계기타 방법으로 회사의 명예 또는 신용을 훼손하거나 업무를 방해하는 행위',
            },
            { text: '기본서비스에 관한 스팸성 홍보 활동을 하는 행위' },
            {
              text: '기본서비스의 강사, 관리교사에게 폭언, 성희롱, 소란, 인격침해, 명예훼손, 위협적 언동, 기망을 하거나 업무 수행을 방해하는 경우 ',
            },
            { text: '잦은 학습 일정 변경' },
            { text: '기타 약관상의 의무를 불이행하는 행위 ' },
            { text: '기타 불법, 부당한 행위' },
          ],
        },
        {
          text: `회사는 회원의 의무를 위반한 회원에 대하여 회사의 판단에 따라 다음과 같은 조치를 할 수 있습니다.`,
          type: 'ordered',
          items: [
            { text: '사전 통보함 없이 임의로 관련 게시물 삭제' },
            { text: '위반 행위의 중지' },
            { text: '일정 기간 동안 기본서비스 이용 정지' },
            { text: '회사가 입은 손해 전액에 대한 배상 청구' },
            { text: '이 약관의 해지 및 회원 탈퇴 처리' },
          ],
        },
        {
          text: `회사가 전 항에 정한 조치를 할 경우 회사는 7일 전에 회원에게 그 사유를 밝혀 통보하며, 7일이 도과한 시점에서 그 효력이 발생합니다. 단, 회원의 연락이 두절되거나 긴급을 요하는 것과 같이 부득이한 경우 선 조치 후 사후 통보할 수 있습니다.`,
        },
      ]}
    />

    <SubTitle>제12조 회원정보의 관리</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회원은 회원 가입 신청 시에 기입한 사항이 변경되었을 경우에는 즉시 기본서비스에서 변경사항을 최신의 정보로 수정하여야 합니다. 단, 아이디, 생년월일, 실명은 변경할 수 없습니다. ',
        },
        {
          text: '변경된 사항을 반영하지 않음으로 인하여 발생하는 손해 및 법 위반 책임은 당해 회원이 전적으로 부담하며, 회사는 이에 대하여 아무런 책임을 지지 않습니다.',
        },
        {
          text: '아이디, 비밀번호에 대한 관리책임은 전적으로 회원에게 있으며, 회원은 아이디, 비밀번호를 타인에게 양도, 대여할 수 없습니다.',
        },
        {
          text: '회사는 귀책사유 없는 아이디, 비밀번호의 유출, 양도, 대여로 인한 손실이나 손해에 대하여 아무런 책임을 지지 않습니다.',
        },
        {
          text: '회원은 회원의 아이디, 비밀번호가 도용되거나 제3자가 무단 사용하고 있음을 인지한 경우, 지체 없이 회사에 통지하여야 하고, 회사의 안내가 있는 경우에는 그에 따라야 합니다. 회원이 회사에 이를 지체 없이 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않은 경우에는 도용 또는 제3자의 무단 사용으로 인한 손실이나 손해에 대하여 회사는 아무런 책임을 지지 않습니다.',
        },
        {
          text: '계정 관리 책임은 회원 개인에게 있으며, 회원은 어떠한 경우에도 본인의 계정을 타인에게 양도하거나 타인으로 하여금 이용하게 하거나 타인의 기본서비스 이용을 위해서 사용하면 안 됩니다.',
        },
        { text: '회원이 복수의 아이디를 보유할 수 없습니다. ' },
      ]}
    />

    <ChapterTitle>제5장 계약해지 및 이용제한</ChapterTitle>

    <SubTitle>제13조 계약해지, 이용 중지요청</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회원은 언제든지 기본서비스 내 정해진 절차를 거쳐 기본서비스 이용계약 해지 또는 이용 중지를 신청할 수 있으며 회사는 이를 즉시 처리합니다.',
        },
        {
          text: '회사는 1년 동안 로그인 하지 않는 경우로서 제3항의 통지일로부터 7일 이내에 로그인 하지 않은 경우 해당 회원의 아이디를 휴면 처리 할 수 있습니다. 해당 회원의 아이디가 휴면 처리된 이후에도 해당 회원이 3년 동안 로그인 하지 않는 경우에는 회사는 해당 회원을 탈퇴 처리할 수 있습니다.',
        },
        {
          text: '회사가 본 조의 휴면 처리 또는 탈퇴 처리를 할 경우 회사는 7일 전에 회원에게 그 사유를 밝혀 통지하며, 최종 통지일로부터 7일이 도과한 시점에서 그 효력이 발생합니다. 회원이 휴면 처리된 경우 회원의 정보는 회원에 다시 로그인을 할 때까지 개인정보처리방침에 따라 별도 보관됩니다.',
        },
        { text: '해지로 인하여 회원에게 발생하는 손해에 대하여 회사는 책임지지 않습니다.' },
      ]}
    />

    <ChapterTitle>제6장 기타</ChapterTitle>

    <SubTitle>제14조 양도 금지</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회사와 회원은 상대방의 사전 서면동의 없이 본 약관 상의 지위나 본 약관에 따른 권리, 의무 또는 책임의 전부 또는 일부를 다른 사람에게 양도·이전, 담보제공하거나 기타의 방법으로 처분하여서는 아니됩니다.',
        },
      ]}
    />

    <SubTitle>제15조 통지</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회사는 회원에게 통지를 하는 경우 회원이 등록한 전자우편 주소 또는 휴대전화번호로 합니다.',
        },
        {
          text: '회사는 회원 전체에 대한 통지의 경우, 이 약관에 명시된 다른 내용이 없는 한, 7일 이상 기본서비스 내의 (1) 게시판 또는 (2) 잘 보이는 공간에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.',
        },
      ]}
    />

    <SubTitle>제16조 광고게재 및 광고주와의 거래</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회사가 회원에게 제공하는 서비스의 일부는 광고 게재를 통한 수익으로부터 나옵니다. 회사는 기본서비스 등에 광고를 게재할 수 있고, 회원은 기본서비스 이용 시 노출되는 광고 게재에 동의합니다.',
        },
        {
          text: '회원이 기본서비스 상에 게재되어 있는 광고를 이용하거나 광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 회원과 광고주 간의 문제이므로 이로 인해 발생하는 손실과 손해에 대해 회사는 어떠한 책임도 지지 않습니다.',
        },
      ]}
    />

    <SubTitle> 제17조 손해배상</SubTitle>

    <Text>
      회사는 회사의 본 약관 위반으로 인하여 회원이 손해를 입게 될 경우 본 약관 및 관련 법령에 따라 회원의
      손해를 배상합니다. 그러나, 회사는 회사의 과실 없이 발생된 회원의 손해에 대해서는 책임을 부담하지
      않습니다. 또한 회사는, 법률상 허용되는 한도 내에서, 간접 손해, 특별 손해, 결과적 손해, 징계적 손해, 및
      징벌적 손해에 대한 책임을 부담하지 않습니다. 회사의 손해배상책임은 회사가 회원으로부터 지급받은 금원을
      한도로 합니다.
    </Text>

    <SubTitle>제18조 분쟁 해결</SubTitle>
    <NestedList
      type="ordered"
      items={[
        {
          text: '회사는 기본서비스 이용과 관련한 회원의 의견이나 불만사항을 신속하게 처리합니다. 단, 신속한 처리가 곤란한 경우에는 그 사유와 처리일정을 통보하여 드립니다. ',
        },
        {
          text: '회원 간 또는 회원과 제3자 간 발생한 분쟁에 대하여 회사는 합리적인 범위 내에서 이를 조정할 수 있습니다. 단, 회사는 회원 상호간 및 회원과 제 3자 상호 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임도 없습니다.',
        },
        {
          text: '회사가 민원처리 및 분쟁조정을 하는 경우 회사는 제3자의 입장에서 공정하게 조정에 임하며, 회원은 신의성실원칙에 따라 성실히 응하여야 합니다.',
        },
        {
          text: '회사와 회원 간에 발생한 분쟁은 『전자상거래 등에서의 소비자보호에 관한 법률』에 의해 설치된 소비자피해 분쟁조정기구의 조정절차에 의해 해결할 수 있습니다.',
        },
      ]}
    />

    <SubTitle>제19조 준거법 및 합의관할</SubTitle>

    <NestedList
      type="ordered"
      items={[
        {
          text: '회사와 회원 간에 제기된 법적 분쟁은 대한민국 법을 준거법으로 합니다.',
        },
        {
          text: '이 약관의 해석과 이 약관과 관련된 법적 분쟁이 발생할 경우 그 분쟁은 서울중앙지방법원을 전속적 관할법원으로 합니다.',
        },
      ]}
    />

    <SubTitle>부칙</SubTitle>
    <Text>이 약관은 2022년 9월 2일부터 적용됩니다.</Text>

    <div className={css({ marginTop: '20px' })}>
      <Link underline="always" href="/terms/old" target="_blank">
        이전 이용약관 보기
      </Link>
    </div>
  </>
);

const TermsPage = () => {
  return (
    <DocumentContext.Provider value={{ variant: 'screen' }}>
      <Layout>{content}</Layout>
    </DocumentContext.Provider>
  );
};

export default TermsPage;
